import React from 'react';
import { ReactComponent as Support } from 'assets/icons/support-chat.svg';
import { SUPPORT_EMAIL } from 'utilities/constants';
import ButtonComponent from 'components/button/buttonComponent';
import CustomTooltip from '../CustomTooltip';

const tooltipId = 'support';
const ContactSupport = () => {
  return (
    <>
      <ButtonComponent
        testID={'mailto'}
        type="outlined-transparent"
        Icon={() => <Support className="fill-med-gray-3" />}
        dataTooltipId={tooltipId}
        iconWidth="w-6 h-6"
        className="rounded-full border-none hover:!bg-inherit p-1.5 duration-300 w-11"
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
          window.location.href = `mailto:${SUPPORT_EMAIL}`;
        }}
      />
      <CustomTooltip
        id={tooltipId}
        place="left"
        content="Сontact admin with your issue"
      />
    </>
  );
};

export default ContactSupport;
